import axios from "axios";
import store from '../store';

const instance = axios.create();

instance.interceptors.request.use((config) => {
    // Retrieve the token from the local storage
    const token = localStorage.getItem("token");

    // If the token exists, add it to the authorization header
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    store.commit("security/setLastRequestOn");
    return config;
});

instance.defaults.baseURL = "/api";

export default instance;